module.exports = __webpack_public_path__ + "static/media/nav.e47cf957.svg";